import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {DialogContentBase, DialogModule, DialogRef, KENDO_DIALOGS} from '@progress/kendo-angular-dialog';
import {EditorModule} from '@progress/kendo-angular-editor';
import {InputsModule} from '@progress/kendo-angular-inputs';
import {ButtonsModule} from '@progress/kendo-angular-buttons';
import {LabelModule} from '@progress/kendo-angular-label';
import {DropDownsModule} from '@progress/kendo-angular-dropdowns';
import {LayoutModule} from '@progress/kendo-angular-layout';
import {AutoFocusDirective} from '../../directives/auto-focus.directive';
import {CasiCloseOptions, FormModes} from '../../common/constants.lib';
import {LoggerService} from '../../shared/logger.service';
import {DisciplineSubscaleType} from '../../models/models.lib';

@Component({
  selector: 'casi-discipline-subscale-add.component',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    DialogModule,
    EditorModule,
    InputsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    LayoutModule,
    AutoFocusDirective,
    KENDO_DIALOGS
  ],
  templateUrl: './discipline-subscale-add.component.html',
  styleUrl: './discipline-subscale-add.component.scss'
})
export class DisciplineSubscaleAddComponent extends DialogContentBase implements OnInit {
  private _disciplineSubscale: DisciplineSubscaleType | undefined;

  @Input() title: string = 'Title Not Set';

  @Input({ required: true }) set disciplineSubscale(val: DisciplineSubscaleType) {
    this._disciplineSubscale = val;
    this.disciplineSubscaleForm.patchValue(this._disciplineSubscale);
  }
  get discipline(): DisciplineSubscaleType | undefined {
    return this._disciplineSubscale;
  };

  private _mode: FormModes = FormModes.NOTSET;
  @Input({ required: true }) set mode(val: FormModes) {
    this._mode = val;
  }
  get mode(): FormModes {
    return this._mode;
  };

  disciplineSubscaleForm: FormGroup;

  constructor(
    public override dialog: DialogRef,
    private fb: FormBuilder,
    private logger: LoggerService,
  ) {
    super(dialog);
    this.disciplineSubscaleForm = this.fb.group(
      {
        id: [null, []],
        discipline_id: [null, []],
        subscale_description: [null, [Validators.required]]
      }
    );
  }

  //#region Form

  get f() {
    return this.disciplineSubscaleForm.controls;
  }
  get subscale_description() {
    return this.disciplineSubscaleForm.get('subscale_description');
  }

  //#endregion

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
  }

  public onCancelAction(): void {
    this.logger.debug(`onCancelAction...`);
    this.dialog.close({ text: CasiCloseOptions.Cancelled });
  }

  public onSaveAction(): void {
    this.logger.debug(`onSaveAction...`, this.disciplineSubscaleForm.value);
    if (this.disciplineSubscaleForm.status !== 'INVALID')
      this.dialog.close({ text: CasiCloseOptions.Saved });
  }
}
